import type { ReactNode } from "react";

type Tone = "neutral" | "success" | "warning" | "danger";

const styles: Record<Tone, string> = {
  neutral: "bg-brand-tint/60 text-brand-dark",
  success: "bg-emerald-100 text-emerald-800",
  warning: "bg-amber-100 text-amber-800",
  danger: "bg-accent/10 text-accent-dark",
};

export function Badge({
  tone = "neutral",
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-block rounded-pill px-2.5 py-0.5 text-xs font-semibold ${styles[tone]}`}
    >
      {children}
    </span>
  );
}
